<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar @on-selected="toolBarSelected">
            <template slot="appliancesMenu">
              <appliances-menu @on-selected="applianceSelect"></appliances-menu>
            </template>
          </graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="pieChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import appliancesMenu from "./components/AppliancesGroupMenu";
import graphToolBar from "@/components/GraphToolBar";
import snackBar from "@/components/SnackBar";

import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    appliancesMenu
  },
  data() {
    return {
      chartOptions: null,
      drillDown: [],
      toolBarData: null,
      appliancesData: null
    };
  },
  created() {

     const formatEnergy = energy => {
      if (energy > 1000000){
        return Number(energy / 1000000).toFixed(2) + " MWh";
      } else if (energy > 1000){
        return Number(energy / 1000).toFixed(2) + " kWh";
      } else {
        return Number(energy / 1).toFixed(2) + " Wh";
      }
    }

    this.chartOptions = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie"
      },
      boost: {
        enabled: false,
      },
      title: {
        text: this.$lang.charts.appliances_energy
      },
      tooltip: {
        yDecimals: 1,
        //pointFormat: "<b>{point.y} Wh</b> ({point.percentage:.1f}%)"
        formatter: function() {
          return (
            this.point.name +
            "<br><b>" +
            formatEnergy(this.point.y) +
            "</b> " + 
            "(" + this.point.percentage.toFixed(1) + "%)"
          );
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            //format: "<b>{point.name}</b>: {point.y} Wh ({point.percentage:.1f}%)"
            formatter: function() {
              return (
                this.point.name +
                " <b>" +
                formatEnergy(this.point.y) +
                "</b> " + 
                "(" + this.point.percentage.toFixed(1) + "%)"
              );
            }
          },
          showInLegend: true
        }
      },
      legend: {
        verticalAlign: "top"
      },
      credits: {
        enabled: false
      },
      series: [
        {
          colorByPoint: true,
          data: []
        }
      ]
    };

    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

  },

  methods: {

    applianceSelect(data){
      this.appliancesData = data;
      if (this.toolBarData){
        this.getAPIData(this.toolBarData, this.appliancesData);
      }
    },

    toolBarSelected(data){
      this.toolBarData = data;
      if (this.appliancesData){
        this.getAPIData(this.toolBarData, this.appliancesData);
      }
    },


    getAPIData(selected, appliancesGroup) {
      const { chart } = this.$refs.pieChart;
      chart.showLoading();

      while (chart.series[0].options._levelNumber > 0) {
          chart.drillUp();
      }

      this.getEnergy(selected)
      .then(totalEnergy => {

        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/nilm/appliances-energy",
          data: {
            token: getSelectedDeviceToken(selected.device.mac),
            phase: "L1,L2,L3",
          from: selected.date.from,
          to: selected.date.to,
          },
          withCredentials: true
        })
          .then(response => {

            let newAppliances = this.getDataForGroup(appliancesGroup, response.data, totalEnergy);
            let otherEnergy = (totalEnergy * 1000) - newAppliances.appliancesEnergy;
            if (otherEnergy < 0){
              otherEnergy = 0;
            }
            const alwaysONIndex = response.data.data.findIndex(resp => resp.name == "Always ON");
            

            // set 1st level always on energy
            if (alwaysONIndex != -1){

              newAppliances.chartData.push({
                name: this.$lang.charts.always_on,
                y: response.data.data[alwaysONIndex].energy,
                visible: false
              });

              otherEnergy = otherEnergy - response.data.data[alwaysONIndex].energy;
            } 

            // set 1st level other energy
            newAppliances.chartData.push({
              name: this.$lang.charts.other,
              y: Number(otherEnergy.toFixed(3)),
              visible: false
            });

            chart.update({
              drilldown: {
                series: newAppliances.drillDowns
              }
            }, false);

            chart.series[0].update({name:appliancesGroup.title}, false);
            chart.series[0].setData(newAppliances.chartData);
            
          })
          .catch(error => {
            if (error.response){
              if (error.response.data.code == 610) {
                this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
                chart.series[0].setData([]);
              } else {
                this.$refs.snackbar.notify(
                  this.$lang.messages.api_communication_error
                );
              }
            }
          });

      });
    },

    getEnergy(selected) {
      return axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/energy",
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          data: "E_I",
          phase: "CUM",
          from: selected.date.from,
          to: selected.date.to,
        },
        withCredentials: true
      })
      .then(response => {
        return response.data.data[0].E_I.CUM;
      })
      .catch(error => {
        if (error.response.data.code === 610) {
          this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
        } else {
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
        }
        //return error;
      });
    },


        getDataForGroup(hierarchyMenu, appliancesEnergy, totalEnergy){
      let result = {
        chartData: [],
        drillDowns: [],
        appliancesEnergy: 0
      }
      let idx = 0;
      let groupEnergy = 0;

      if (hierarchyMenu.children) {
        for (idx = 0; idx < hierarchyMenu.children.length; idx++) {
          if (hierarchyMenu.children[idx].isLeaf) {

            const dataIndex = appliancesEnergy.data.findIndex(resp => resp.ID == hierarchyMenu.children[idx].data.ID_appliance);
            
            if (dataIndex != -1){
              groupEnergy = appliancesEnergy.data[dataIndex].energy;
            } else {
              groupEnergy = 0;
            }

            if (groupEnergy > 0) {
              let groupChartData = {
                name: hierarchyMenu.children[idx].title,
                y: Number((groupEnergy).toFixed(3)),
                visible: true,
              };

              result.chartData.push(groupChartData);
              result.appliancesEnergy += groupEnergy;
            }

          } else {

            const childrenResult = this.getDataForGroup2(hierarchyMenu.children[idx], appliancesEnergy, totalEnergy);
            if (childrenResult.appliancesEnergy > 0) {

              let groupChartData = {
                name: hierarchyMenu.children[idx].title,
                y: Number((childrenResult.appliancesEnergy).toFixed(3)),
                visible: true,
                drilldown: hierarchyMenu.children[idx].title
              };

              result.chartData.push(groupChartData);
              result.appliancesEnergy += childrenResult.appliancesEnergy;

              childrenResult.drillDowns.forEach(drillDown => {
                result.drillDowns.push(drillDown);
              });
            }

          }
        }
      }
      return result;
    },

    getDataForGroup2(hierarchyMenu, appliancesEnergy, totalEnergy){
      let result = {
        drillDowns: [],
        appliancesEnergy: 0
      }
      let idx = 0;
      let groupEnergy = 0;

      result.drillDowns.push({
          name: hierarchyMenu.title,
          id: hierarchyMenu.title,
          data: []
      });
      const drillDownsLength = result.drillDowns.length;

      if (hierarchyMenu.children) {
        for (idx = 0; idx < hierarchyMenu.children.length; idx++) {
          if (hierarchyMenu.children[idx].isLeaf) {

            const dataIndex = appliancesEnergy.data.findIndex(resp => resp.ID == hierarchyMenu.children[idx].data.ID_appliance);
            if (dataIndex != -1){
              result.appliancesEnergy += appliancesEnergy.data[dataIndex].energy;

              result.drillDowns[drillDownsLength - 1].data.push({
                name: hierarchyMenu.children[idx].title,
                y: appliancesEnergy.data[dataIndex].energy
              });
            }

          } else {
            const childrenResult = this.getDataForGroup2(hierarchyMenu.children[idx], appliancesEnergy, totalEnergy);
            
            if (childrenResult.appliancesEnergy > 0){
              result.appliancesEnergy += childrenResult.appliancesEnergy;

              result.drillDowns[drillDownsLength - 1].data.push({
                name: hierarchyMenu.children[idx].title,
                y: childrenResult.appliancesEnergy,
                drilldown: hierarchyMenu.children[idx].title
              });

              childrenResult.drillDowns.forEach(drillDown => {
                result.drillDowns.push(drillDown);
              });
            }
          }
        }
            
            let otherEnergy = (totalEnergy * 1000) - result.appliancesEnergy;
            const alwaysONIndex = appliancesEnergy.data.findIndex(resp => resp.name == "Always ON");

            // set drill down levels always on energy
            if (alwaysONIndex != -1){
              result.drillDowns[drillDownsLength - 1].data.push({
                name: this.$lang.charts.always_on,
                y: appliancesEnergy.data[alwaysONIndex].energy,
                visible: false
              });

              otherEnergy = otherEnergy - appliancesEnergy.data[alwaysONIndex].energy;
            }

            // set 1st level other energy
            result.drillDowns[drillDownsLength - 1].data.push({
              name: this.$lang.charts.other,
              y: Number(otherEnergy.toFixed(3)),
              visible: false
            });

      }

      return result;
    }

  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>